module.exports = __webpack_public_path__ + "static/media/MHRP77N0010.40ae2d90.svg";